import { useRegistrationProps } from "@/context/useRegistrationProps";
import { useEffect } from "react";

import { onLoadEvents } from "@/components/common/cleverTapEvents";

const useOnLoadTracking = () => {
  const { handleEventTracking, screenType } = useRegistrationProps() as {
    handleEventTracking: Function;
    screenType: keyof typeof onLoadEvents;
  };
  useEffect(() => {
    handleEventTracking({
      eventType: "eventPush",
      eventName: "Registration_Filled",
      eventProps: { [onLoadEvents[screenType]]: true },
    });
  }, []);
};

export default useOnLoadTracking;
